import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const FaqOverlayWrapper = styled.div`
  margin: 132px 16px 16px 16px;
  color: ${colors.black};

  ${mediaDesktop(css`
    margin: 144px 122px 124px 122px;
  `)}
`;

export const Title = styled.div`
  ${({ theme: { locale } }) => setTypography('heading1', locale)}
  margin-bottom: 56px;

  ${mediaDesktop(css`
    margin-bottom: 80px;
  `)}
`;

export const QuestionWrapper = styled.div`
  margin-bottom: 64px;

  ${Title} {
    ${({ theme: { locale } }) => setTypography('heading5', locale)}
    margin-bottom: 20px;

    ${mediaDesktop(css`
      margin-bottom: 24px;
    `)}
  }

  ${mediaDesktop(css`
    margin-bottom: 80px;
  `)}
`;

export const Text = styled.div`
  ${({ theme: { locale } }) => setTypography('body', locale)}
`;

export const OpportunitiesWrapper = styled.div`
  padding: 20px;
  background-color: ${colors.concrete};

  ${Title} {
    ${({ theme: { locale } }) => setTypography('heading4', locale)}
    margin-bottom: 40px;

    ${mediaDesktop(
      css`
        margin-bottom: 57px;
      `
    )}
  }

  ${mediaDesktop(css`
    padding: 24px;
  `)}
`;
